import React, { type ReactNode } from "react";
import { Box } from "@mui/material";
import { publicInfoCalloutSx } from "./constants/publicInfoPageStyles";

type PublicInfoCalloutProps = {
  children: ReactNode;
  testId?: string;
};

const PublicInfoCallout: React.FC<PublicInfoCalloutProps> = ({
  children,
  testId
}) => (
  <Box sx={publicInfoCalloutSx} data-testid={testId}>
    {children}
  </Box>
);

export default PublicInfoCallout;
